<template>
  <div class="product-card-badge">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@import '../../scss/variables';

.product-card-badge {
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 3px 7px;
  border: 1px solid #d3d5d6; // not part of the existing color variables
  border-radius: 3px;

  font-size: 14px;
  color: #7c8085; // not part of the existing color variables
  background: #fafafa;
  pointer-events: none;
}
</style>
